import { createStore } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { createValidationSlice } from './validation';
import type { ValidationSlice } from './validation';
import { createEvaluationSlice } from './evaluation';
import type { EvaluationSlice } from './evaluation';
import { createUISlice } from './ui';
import type { UISlice } from './ui';
import { createGraphSlice } from './graph';
import type { GraphSlice } from './graph';
import { createCommandSlice } from './command';
import type { CommandSlice } from './command';
import type { IEvaluation, IGraph, StoreSlice } from '@/store';
import type { GraphId } from '../types';

export interface GraphState {
  graph: GraphSlice & IGraph;
  valid: ValidationSlice;
  eval: EvaluationSlice & IEvaluation;
  cmd: CommandSlice;
  ui: UISlice;
}

export type InitGraphState = {
  id: GraphId;
};

export type GraphStore = ReturnType<typeof createGraphStore>;

export const createGraphStore = (
  global: StoreSlice,
  initProps: InitGraphState,
) => {
  return createStore<GraphState>()(
    immer((...a) => ({
      graph: createGraphSlice(global, initProps.id)(...a),
      valid: createValidationSlice(global, initProps.id)(...a),
      eval: createEvaluationSlice(global, initProps.id)(...a),
      cmd: createCommandSlice(global)(...a),
      ui: createUISlice(...a),
    })),
  );
};
